/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Capture_No_MatchInputs */

const en_capture_no_match = /** @type {(inputs: Capture_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A calendar event matched no student:`)
};

const he_capture_no_match = /** @type {(inputs: Capture_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אירוע יומן לא תאם לאף תלמיד:`)
};

/**
* | output |
* | --- |
* | "A calendar event matched no student:" |
*
* @param {Capture_No_MatchInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const capture_no_match = /** @type {((inputs?: Capture_No_MatchInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Capture_No_MatchInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_capture_no_match(inputs)
	return he_capture_no_match(inputs)
});